import PageHeader from "@/components/PageHeader";
import { useProjectBreadcrumb } from "../hooks/useProjectBreadcrumb";
import { ProjectDetailsAndNavigation } from "./ProjectDetailsAndNavigation";
import { useProjectQuery } from "@/modules/projects/hooks/useProjectQuery";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";
import { PeriodConfirmationAlert } from "./period-confirmation/PeriodConfirmationAlert";

export default function ProjectBasicView() {
  const projectId = useProjectId();
  const query = useProjectQuery(projectId);
  const breadcrumbItems = useProjectBreadcrumb(query);

  return (
    <>
      <PageHeader breadcrumbItems={breadcrumbItems} />
      <div className="space-y-2">
        <ProjectDetailsAndNavigation />
        <PeriodConfirmationAlert
          projectId={projectId}
          show={query.data?.show_period_confirmation_alert}
        />
      </div>
    </>
  );
}
